import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  const location = useLocation();

  const isTeamReport = /^\/team\/[^/]+\/(leader|overview)/.test(location.pathname);
  const hideChrome = location.pathname.startsWith('/assessment/') || location.pathname.startsWith('/results/') || isTeamReport;

  const fullWidthPages = ['/', '/start'];
  const isFullWidth = fullWidthPages.includes(location.pathname) || location.pathname.startsWith('/results/');

  if (hideChrome) {
    return <>{children}</>;
  }

  return (
    <div className="layout">
      <Header />
      <main className={`main-content ${isFullWidth ? 'full-width' : ''}`}>
        {children}
      </main>
      <footer className="footer">
        <div className="footer-content">
          <p className="footer-brand">
            <span className="footer-logo">E.Q.U.I.P. <span className="text-blue">360</span></span>
            <span className="footer-tagline">Emotional Quotient Under Intelligent Pressure</span>
          </p>
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} Mick Hunt Official. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
